import { create } from 'zustand';
import { ApiUtils, CardApi, type CardEntity, type StoreBaseReturn } from '@shared/api';

interface UseActivateCardStore {
  loading: boolean;
  data: CardEntity[];
  error: string | null;
  activateCard: (accountId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<CardEntity[]>>;
  clear: () => void;
}

export const useActivateCardStore = create<UseActivateCardStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  activateCard: async (accountId, signal) => {
    try {
      set({ loading: true, data: [], error: null });
      const result = await CardApi.activateCard(accountId, signal);
      set({ loading: false, data: result || [] });
      return { loading: false, data: result || [], error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: [], error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: [], error: null }),
}));
